<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal create-notice-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="nextStep()" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Set Notice Schedule</h4>
                </div>
                <div class="modal-body">
                    <div class="schedule-content">
                        <!-- ___ Duration ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Duration</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control" name="buildingId" [ngModel]="data.duration">
                                    <option value="" hidden></option>
                                    <option *ngFor="let duration of listDuration" [value]="duration.value">{{duration.name}}</option>
                                </select>
                            </div>
                        </div>

                        <!-- ___ Date / Time Start ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Start</label>
                            </div>
                            <div class="col-md-8 inlineDateAndTime">
                                <mat-form-field>
                                    <input matInput [(ngModel)]="startDate" [max]="maxDate" name="startDate"
                                           (focus)="startPicker.open()" (click)="startPicker.open()"
                                           [matDatepicker]="startPicker" placeholder="Date">
                                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startPicker></mat-datepicker>
                                </mat-form-field>
                                <div class="input-group bootstrap-timepicker timepicker"
                                     (click)="openTimepicker('timepicker1')">
                                    <input id="timepicker1" class="form-control input-small" name="time" [ngModel]="time" required>
                                    <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                                </div>
                            </div>
                        </div>

                        <!-- ___ Date / Time End ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>End</label>
                            </div>
                            <div class="col-md-8 inlineDateAndTime">
                                <mat-form-field>
                                    <input matInput [(ngModel)]="endDate" [min]="startDate" name="endDate"
                                           (focus)="endPicker.open()" (click)="endPicker.open()"
                                           [matDatepicker]="endPicker" placeholder="Date">
                                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #endPicker></mat-datepicker>
                                </mat-form-field>
                                <div class="input-group bootstrap-timepicker timepicker"
                                     (click)="openTimepicker('timepicker2')">
                                    <input id="timepicker2" class="form-control input-small" name="time" [ngModel]="time" required>
                                    <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                                </div>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-sm-3 advance-schedule-tuner" [ngClass]="listPlaylist.length > 1 ? 'col-sm-offset-6' : 'col-sm-offset-9'">
                                <!--<a href="" data-toggle="collapse" data-target="#collapseExample_{{inx}}"><i class="fa fa-wrench"></i> Advance Schedule</a>-->
                                <a data-toggle="collapse" data-target="#collapseExample"><i class="fa fa-wrench"></i> Advance Schedule</a>
                            </div>
                        </div>
                        <div class="_advance-item collapse" id="collapseExample">
                            <div class="_wrap">
                                <div class="row row-fx">
                                    <div class="col-sm-3 col">
                                        <div class="hours-days-weekdays-months-header">
                                            <h4>Hours</h4>
                                            <a class="_select-all">Select all</a>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="1am" [(ngModel)]="advancedHours[0]">
                                                        <span>1 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="2am" [(ngModel)]="advancedHours[1]">
                                                        <span>2 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="3am" [(ngModel)]="advancedHours[2]">
                                                        <span>3 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="4am" [(ngModel)]="advancedHours[3]">
                                                        <span>4 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="5am" [(ngModel)]="advancedHours[4]">
                                                        <span>5 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="6am" [(ngModel)]="advancedHours[5]">
                                                        <span>6 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="7am" [(ngModel)]="advancedHours[6]">
                                                        <span>7 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="8am" [(ngModel)]="advancedHours[7]">
                                                        <span>8 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="9am" [(ngModel)]="advancedHours[8]">
                                                        <span>9 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="10am" [(ngModel)]="advancedHours[9]">
                                                        <span>10 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="11am" [(ngModel)]="advancedHours[10]">
                                                        <span>11 AM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="12pm" [(ngModel)]="advancedHours[11]">
                                                        <span>12 PM</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-xs-6">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="1pm" [(ngModel)]="advancedHours[12]">
                                                        <span>1 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="2pm" [(ngModel)]="advancedHours[13]">
                                                        <span>2 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="3pm" [(ngModel)]="advancedHours[14]">
                                                        <span>3 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="4pm" [(ngModel)]="advancedHours[15]">
                                                        <span>4 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="5pm" [(ngModel)]="advancedHours[16]">
                                                        <span>5 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="6pm" [(ngModel)]="advancedHours[17]">
                                                        <span>6 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="7pm" [(ngModel)]="advancedHours[18]">
                                                        <span>7 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="8pm" [(ngModel)]="advancedHours[19]">
                                                        <span>8 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="9pm" [(ngModel)]="advancedHours[20]">
                                                        <span>9 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="10pm" [(ngModel)]="advancedHours[21]">
                                                        <span>10 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="11pm" [(ngModel)]="advancedHours[22]">
                                                        <span>11 PM</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="12am" [(ngModel)]="advancedHours[23]">
                                                        <span>12 AM</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 col left-border-divider">
                                        <div class="hours-days-weekdays-months-header">
                                            <h4>Days</h4>
                                            <a class="_select-all">Select all</a>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day1" [(ngModel)]="advancedDays[0]">
                                                        <span>1</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day2" [(ngModel)]="advancedDays[1]">
                                                        <span>2</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day3" [(ngModel)]="advancedDays[2]">
                                                        <span>3</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day4" [(ngModel)]="advancedDays[3]">
                                                        <span>4</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day5" [(ngModel)]="advancedDays[4]">
                                                        <span>5</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day6" [(ngModel)]="advancedDays[5]">
                                                        <span>6</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day7" [(ngModel)]="advancedDays[6]">
                                                        <span>7</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day8" [(ngModel)]="advancedDays[7]">
                                                        <span>8</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day9" [(ngModel)]="advancedDays[8]">
                                                        <span>9</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day10" [(ngModel)]="advancedDays[9]">
                                                        <span>10</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day11" [(ngModel)]="advancedDays[10]">
                                                        <span>11</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day12" [(ngModel)]="advancedDays[11]">
                                                        <span>12</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day13" [(ngModel)]="advancedDays[12]">
                                                        <span>13</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day14" [(ngModel)]="advancedDays[13]">
                                                        <span>14</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day15" [(ngModel)]="advancedDays[14]">
                                                        <span>15</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day16" [(ngModel)]="advancedDays[15]">
                                                        <span>16</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-xs-6">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day17" [(ngModel)]="advancedDays[16]">
                                                        <span>17</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day18" [(ngModel)]="advancedDays[17]">
                                                        <span>18</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day19" [(ngModel)]="advancedDays[18]">
                                                        <span>19</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day20" [(ngModel)]="advancedDays[19]">
                                                        <span>20</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day21" [(ngModel)]="advancedDays[20]">
                                                        <span>21</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day22" [(ngModel)]="advancedDays[21]">
                                                        <span>22</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day23" [(ngModel)]="advancedDays[22]">
                                                        <span>23</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day24" [(ngModel)]="advancedDays[23]">
                                                        <span>24</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day25" [(ngModel)]="advancedDays[24]">
                                                        <span>25</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day26" [(ngModel)]="advancedDays[25]">
                                                        <span>26</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day27" [(ngModel)]="advancedDays[26]">
                                                        <span>27</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day28" [(ngModel)]="advancedDays[27]">
                                                        <span>28</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day29" [(ngModel)]="advancedDays[28]">
                                                        <span>29</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day30" [(ngModel)]="advancedDays[29]">
                                                        <span>30</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="day31" [(ngModel)]="advancedDays[30]">
                                                        <span>31</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 col left-border-divider">
                                        <div class="hours-days-weekdays-months-header">
                                            <h4>Weekdays</h4>
                                            <a class="_select-all">Select All</a>
                                        </div>
                                        <!--<a class="_select-all">Unselect All</a>-->

                                        <div class="row">
                                            <div class="col-xs-4">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="monday" [(ngModel)]="advancedWeekDays[0]">
                                                        <span>Monday</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="tuesday" [(ngModel)]="advancedWeekDays[1]">
                                                        <span>Tuesday</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="wednesday" [(ngModel)]="advancedWeekDays[2]">
                                                        <span>Wednesday</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="thursday" [(ngModel)]="advancedWeekDays[3]">
                                                        <span>Thursday</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="friday" [(ngModel)]="advancedWeekDays[4]">
                                                        <span>Friday</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="saturday" [(ngModel)]="advancedWeekDays[5]">
                                                        <span>Saturday</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="sunday" [(ngModel)]="advancedWeekDays[6]">
                                                        <span>Sunday</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 col left-border-divider">
                                        <div class="hours-days-weekdays-months-header">
                                            <h4>Month</h4>
                                            <a class="_select-all">Select All</a>
                                        </div>
                                        <!--<a class="_select-all">Unselect All</a>-->
                                        <div class="row">
                                            <div class="col-xs-2">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="january" [(ngModel)]="advancedMonth[0]">
                                                        <span>January</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="february" [(ngModel)]="advancedMonth[1]">
                                                        <span>February</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="march" [(ngModel)]="advancedMonth[2]">
                                                        <span>March</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="april" [(ngModel)]="advancedMonth[3]">
                                                        <span>April</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="may" [(ngModel)]="advancedMonth[4]">
                                                        <span>May</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="june" [(ngModel)]="advancedMonth[5]">
                                                        <span>June</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="july" [(ngModel)]="advancedMonth[6]">
                                                        <span>July</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="august" [(ngModel)]="advancedMonth[7]">
                                                        <span>August</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="september" [(ngModel)]="advancedMonth[8]">
                                                        <span>September</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="october" [(ngModel)]="advancedMonth[9]">
                                                        <span>October</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="november" [(ngModel)]="advancedMonth[10]">
                                                        <span>November</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" name="december" [(ngModel)]="advancedMonth[11]">
                                                        <span>December</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--<div class="row text-center space-30">-->
                            <!--<button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>-->
                        <!--</div>-->
                    </div>
                    <div class="_footer" *ngIf="noticesService.step && noticesService.step != 'main'">
                        <div class="_f-wrap">
                            <a (click)="back()" class="btn btn-back btn-default btn-lg">Back</a>
                            <button type="submit" class="btn btn-save btn-primary btn-lg">
                                <span *ngIf="noticesService.step != 'schedule'">Save & Continue</span>
                                <span *ngIf="noticesService.step == 'schedule'">Save</span>
                            </button>
                            <div class="_steps-items">
                                <ul>
                                    <li [ngClass]="{'active': noticesService.step == 'message' || noticesService.step == 'templates'}" class="passed"><span>Notice Message</span></li>
                                    <li [ngClass]="{'active': noticesService.step == 'schedule'}"><span>Schedule</span></li>
                                    <li [ngClass]="{'active': noticesService.step == 'info'}"><span>Notice Info</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/notices/schedule-notice-modal/schedule-notice-modal.component.html